import React from "react";
import Layout from "../components/layout/Layout";
import { Routes, Route as RouteItem } from "react-router-dom";
import Home from "../pages/home/Home";
import FlightListing from "../pages/flights/FlightListing";
import MyProfile from "../pages/myprofile/MyProfile";
import VerifyEmail from "../pages/verifyemail/VerifyEmail";
import ReviewBookingNew from "../pages/reviewbooking/ReviewBookingNew";
import MyTrips from "../pages/mytrips/MyTrips";
import TripConfirmation from "../pages/mytrips/confirmation/TripConfirmation";
import BookingCancellation from "../pages/cancellation/BookingCancellation";
import TicketPrint from "../pages/cancellation/TicketPrint";
import PendingConfirmation from "../pages/mytrips/confirmation/PendingConfirmation";
import TripDetails from "../pages/mytrips/tripdetails/TripDetails";
import CancelledTripDetails from "../pages/mytrips/tripdetails/CancelledTripdetails";
import CancelConfirmation from "../pages/mytrips/confirmation/CancelConfirmation";
import FailedConfirmation from "../pages/mytrips/confirmation/FailedConfirmation";
import Wallet from "../pages/wallet/Wallet";
import WithdrawalHistory from "../pages/wallet/WithdrawalHistory";
import WalletTransctionHistory from "../pages/wallet/WalletTransctionHistory";
import WithdrawalRequestView from "../pages/wallet/WithdrawalRequestView";
import TermsOfUse from "../pages/termsofuse/TermsOfUse";
import TourList from "../pages/tour/TourList";
import TourDetailPage from "../pages/tour/TourDetailPage";
import WeekendServiceDetail from "../pages/home/WeekendServiceDetail";
import GiftCodeLedger from "../pages/wallet/GiftCodeLedger";
import Topup from "../pages/topup/Topup";
import TopupRequestView from "../pages/topup/TopupRequestView";
import TopupRequestFormPage from "../pages/topup/TopupRequestFormPage";

const MainRouter = () => {
  return (
    <Routes>
      <RouteItem path="/" element={<Layout />}>
        <RouteItem index={true} element={<Home />} />
        <RouteItem path={"terms-conditions"} element={<TermsOfUse />} />
        <RouteItem path={"flights"} element={<Home />} />
        <RouteItem path={"hotels"} element={<Home />} />
        <RouteItem path={"holidaypackages"} element={<Home />} />
        <RouteItem path={"buses"} element={<Home />} />
        <RouteItem path="flights/search" element={<FlightListing />} />
        <RouteItem path="my-profile" element={<MyProfile />} />
        <RouteItem
          path="flights/reviewbooking"
          element={<ReviewBookingNew />}
        />
        {/* <RouteItem
          path="flights/reviewbooking/seatselection"
          element={<SeatSelectionSlideTest />}
        /> */}
        <RouteItem path="flights/mytrips" element={<MyTrips />} />
        <RouteItem
          path="flights/completed-trip-details"
          element={<TripDetails />}
        />
        <RouteItem
          path="flights/upcoming-trip-details"
          element={<TripDetails />}
        />
        <RouteItem
          path="flights/failed-trip-details"
          element={<TripDetails />}
        />
        <RouteItem
          path="flights/cancelled-trip-details"
          element={<CancelledTripDetails />}
        />
        <RouteItem
          path="flights/cancellation"
          element={<BookingCancellation />}
        />
        <RouteItem
          path="flights/trip-confirmation"
          element={<TripConfirmation />}
        />
        <RouteItem
          path="flights/pending-confirmation"
          element={<PendingConfirmation />}
        />
        <RouteItem
          path="flights/failed-confirmation"
          element={<FailedConfirmation />}
        />
        <RouteItem
          path="flights/cancel-confirmation"
          element={<CancelConfirmation />}
        />
        <RouteItem path="flights/ticket-print" element={<TicketPrint />} />
        <RouteItem path="wallet" element={<Wallet />} />
        <RouteItem
          path="walletwithdrawalhistory"
          element={<WithdrawalHistory />}
        />
        <RouteItem path="topuphistory" element={<Topup />} />
        <RouteItem
          path="wallettransctionshistory"
          element={<WalletTransctionHistory />}
        />
        <RouteItem
          path="walletwithdrawrequestview"
          element={<WithdrawalRequestView />}
        />
        <RouteItem
          path="topuprequest/view"
          element={<TopupRequestView />}
        />
        <RouteItem
          path="topuprequest/add"
          element={<TopupRequestFormPage />}
        />
        <RouteItem path="tour/" element={<TourList />} />
        <RouteItem path="tour/:SectorURL/" element={<TourList />} />
        <RouteItem path="tour/package/:TourURL/" element={<TourDetailPage />} />
        <RouteItem
          path="services/:ServiceURL/"
          element={<WeekendServiceDetail />}
        />
        <RouteItem path="giftcodeledger" element={<GiftCodeLedger />} />
      </RouteItem>
      <RouteItem path="verify-email" element={<VerifyEmail />} />
    </Routes>
  );
};

export default MainRouter;
